function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBluetoothOutline = function SvgBluetoothOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 42,
    viewBox: "0 0 41 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 21,
    r: 20,
    stroke: props.fill,
    strokeLinecap: "round",
    strokeDasharray: "1 6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4583 15.9582L25.5416 26.0415L20.5 31.0832V10.9165L25.5416 15.9582L15.4583 26.0415",
    stroke: props.fill,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};
export default SvgBluetoothOutline;